import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../../services/api';
import { FileText, MessageCircle } from 'lucide-react';
import { toast } from 'sonner';

export default function ForgotPassword() {
  const [whatsapp, setWhatsapp] = useState('');
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await api.post('/auth/forgot-password', { whatsapp });
      setResult(res.data);
    } catch (err) {
      toast.error('Erro ao processar solicitação');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4"
         style={{ backgroundImage: 'radial-gradient(ellipse at 50% 50%, rgba(249,115,22,0.08) 0%, transparent 70%)' }}>
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <img src="/icon-192.png" alt="OrcFácil" className="w-32 h-32 rounded-2xl object-cover mb-4 mx-auto block shadow-[0_0_40px_rgba(249,115,22,0.35)]" />
          <h1 className="font-heading text-3xl font-bold text-white">OrcFácil</h1>
        </div>

        <div className="bg-zinc-900 border border-zinc-800 rounded-2xl p-8">
          <h2 className="font-heading text-xl font-semibold text-white mb-2">Recuperar senha</h2>
          <p className="text-sm text-zinc-400 mb-6">Informe o WhatsApp cadastrado na sua conta.</p>

          {!result ? (
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label className="field-label">WhatsApp</label>
                <input
                  data-testid="whatsapp-input"
                  required
                  className="field-input"
                  placeholder="(99) 99999-9999"
                  value={whatsapp}
                  onChange={e => setWhatsapp(e.target.value)}
                />
              </div>
              <button
                data-testid="forgot-submit-btn"
                type="submit"
                disabled={loading}
                className="w-full bg-orange-500 hover:bg-orange-400 disabled:opacity-50 text-white font-semibold py-2.5 px-4 rounded-xl transition-colors"
              >
                {loading ? 'Processando...' : 'Enviar link de recuperação'}
              </button>
            </form>
          ) : (
            <div className="space-y-4">
              {result.wpp_link ? (
                <>
                  <div className="bg-green-500/10 border border-green-500/30 rounded-lg p-4 text-sm text-green-400">
                    Link gerado para <strong>{result.user_nome}</strong>!
                  </div>
                  <a
                    href={result.wpp_link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center justify-center gap-2 w-full bg-[#25D366] hover:bg-[#20c55e] text-white font-semibold py-2.5 px-4 rounded-xl transition-colors"
                  >
                    <MessageCircle size={18} />
                    Enviar via WhatsApp
                  </a>
                  <div className="text-xs text-zinc-500 break-all">
                    Link: <span className="text-zinc-400">{result.reset_link}</span>
                  </div>
                </>
              ) : (
                <div className="bg-zinc-800 rounded-lg p-4 text-sm text-zinc-400">
                  {result.message}
                </div>
              )}
            </div>
          )}

          <p className="text-center text-sm text-zinc-500 mt-4">
            <Link to="/login" className="text-orange-400 hover:text-orange-300">Voltar ao login</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
